import { Block, Inline } from '@contentful/rich-text-types'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import {
  blogPostUrl,
  landingUrl,
  staticPagePaths,
  categoryLandingUrl,
  methodUrl,
} from '../locale/pathing'
import { IndustryOrMaterial, TypeOfTesting } from '../logic/catalog'
import { ContentfulLinkReference } from '../logic/richText'
import { StaticPage } from '../logic/staticPage'

export const ContentfulLink = ({
  children,
  node,
}: {
  node: Block | Inline
  children: React.ReactNode
}) => {
  const { locale } = useContext(LocaleContext)

  const target = node.data.target as ContentfulLinkReference

  // Target can become undefined when target node is deleted from Contentful
  if (!target) {
    throw new Error('Entry hyperlink to deleted page')
  }

  if (target.__typename === 'ContentfulBlogPost' && target.slug) {
    return <Link to={blogPostUrl(locale, target.slug)}>{children}</Link>
  }
  if (target.__typename === 'ContentfulLandingPage') {
    const { slug, pageType } = target

    return slug && pageType ? (
      <Link to={landingUrl(locale, slug, pageType)}>{children}</Link>
    ) : null
  }
  if (
    target.__typename === 'ContentfulStaticArticle' &&
    target.pageId &&
    Object.values(StaticPage).includes(target.pageId)
  ) {
    return <Link to={staticPagePaths[target.pageId][locale]}>{children}</Link>
  }

  if (target.__typename === 'ContentfulCategoryLandingPage' && target.key) {
    return (
      <Link
        to={categoryLandingUrl(
          locale,
          target.key as IndustryOrMaterial | TypeOfTesting,
        )}
      >
        {children}
      </Link>
    )
  }
  if (target.__typename === 'ContentfulMethodPage' && target.slug) {
    return <Link to={methodUrl(locale, target.slug)}>{children}</Link>
  }

  throw new Error(`Invalid content type ${node.nodeType} in entry hyperlink`)
}
